import DateUtil from '../../util/DateUtil'

export function submissionTimeLabel(date: Date): string {
  return DateUtil.getRelativeTimeString(date)
}
